<template>
  <div class="">
    <template v-if="!isEnd">
      <span>{{ h }}时</span><span>{{ m }}分</span><span>{{ s }}秒</span>
    </template>
    <span v-else>超时反馈</span>
  </div>
</template>

<script>
export default {
  props: {
    time: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      h: 0,
      m: 0,
      s: 0,
      isEnd: false
    }
  },
  created() {
    if (this.time) {
      this.countTime()
    }
  },
  methods: {
    countTime() {
      //获取当前时间  
      var date = new Date();
      var now = date.getTime();
      // //设置截止时间  
      // var str="2017/5/17 00:00:00";
      var endDate = new Date(new Date(this.time).getTime() + 24 * 60 * 60 * 1000);
      var end = endDate.getTime();
      //时间差  
      var leftTime = end - now;
      if (leftTime >= 1000) {
        this.h = Math.floor((leftTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        this.m = Math.floor((leftTime % (1000 * 60 * 60)) / (1000 * 60));
        this.s = Math.floor((leftTime % (1000 * 60)) / 1000);
        //递归每秒调用countTime方法，显示动态时间效果  
        setTimeout(() => {
          this.countTime()
        }, 1000);
      } else {
        this.isEnd = true
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
